var __default__ = {
  name: "PreviewModal",
  title: "お知らせプレビュー"
};
import { computed } from "vue";
import { useStore } from "vue2-helpers/vuex";
import moment from "moment";
import UrlToLink from "@/components/common/UrlToLink.vue";
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    message: {
      type: Object,
      default: function _default() {}
    },
    enquete: {
      type: Object,
      default: function _default() {}
    },
    processReviewing: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props; // @ts-check

    var store = useStore();
    var me = computed(function () {
      return store.state.me;
    });
    var school = computed(function () {
      return store.state.school;
    });
    var enqueteEnd = computed(function () {
      var _props$enquete;

      return (_props$enquete = props.enquete) !== null && _props$enquete !== void 0 && _props$enquete.implement_to && moment(props.enquete.implement_to).isValid() ? moment(props.enquete.implement_to).format("llll") : "";
    });
    return {
      __sfc: true,
      props: props,
      store: store,
      me: me,
      school: school,
      enqueteEnd: enqueteEnd,
      UrlToLink: UrlToLink
    };
  }
});